import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function EditPhotoSolid({ theme, ...props }) {
  return (
    <svg
      aria-labelledby={props.ariaTags.labelledBy}
      aria-hidden={props.ariaTags.hidden}
      className={cx(theme.container, theme[props.svg], props.className)}
      shapeRendering="geometricPrecision"
      tabIndex={props.tabIndex}
      vectorEffect="non-scaling-stroke"
      viewBox="-4 -4 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      {props.title ? (
        <title id={props.ariaTags.labelledBy} lang="en">
          {props.title}
        </title>
      ) : null}
      <g fill="none" fillRule="evenodd">
        <path
          className={theme.fill}
          d="M13.0996.60348913h7.7846667l2.858 3.31295652h4.9506666c1.7173334 0 3.1226667 1.49069565 3.1226667 3.31363044V27.1084891c0 1.8222609-1.4053333 3.3129566-3.1226667 3.3129566H3.70626667c-1.718 0-3.12333334-1.4906957-3.12333334-3.3129566V7.23007609c0-1.82293479 1.40533334-3.31363044 3.12333334-3.31363044h4.95066666L11.5142667.60348913H13.0996zM6.8296 22.134337v3.7267391h3.6866667L21.3896 14.8695543l-3.6866667-3.7267391L6.8296 22.134337zm17.4113333-10.1471087c.3826667-.3875.3826667-1.0128913 0-1.4010653l-2.3006666-2.32499996c-.3833334-.3875-1.0026667-.3875-1.386 0l-1.8 1.81889126L22.4416 13.8061196l1.7993333-1.8188913z"
        />
      </g>
    </svg>
  )
}

EditPhotoSolid.propTypes = {
  ariaTags: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  svg: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  className: PropTypes.string,
  tabIndex: PropTypes.string,
  title: PropTypes.string,
}
